export default "__VITE_ASSET__070d40ff__"